import { Text } from '@Components/Common/Text';
import { PRODUCT_OPTIONS_MODAL_WIDTH } from '@Constants/LeftDrawer';
import useCheckoutPresenter from '@Screens/Checkout/presenter';
import OwnableTheme from '@Theme';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Hoverable } from 'react-native-web-hooks';
import styled, { css } from 'styled-components/native';

import { useCheckoutStore } from '~stores/checkout';

const Wrapper = styled.View<{ position: string }>`
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 0;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  width: ${
    // @ts-expect-error
    PRODUCT_OPTIONS_MODAL_WIDTH
  }px;
  min-height: 200px;
  padding: 70px;
  ${({
    // @ts-expect-error
    position,
  }) => position}
`;

const Title = styled.Text`
  font-size: 22px;
  font-weight: 700;
  font-family: ${OwnableTheme.fonts.gilroy.regular};
  line-height: 27px;
  color: black;
  letter-spacing: 0.03em;
  margin-bottom: 20px;
`;

const OptionWrapper = styled.Pressable<{
  isLast?: boolean;
}>`
  display: flex;
  width: 100%;
  ${({ isLast }) =>
    !isLast &&
    css`
      border-bottom-width: 2px;
      border-bottom-color: #dedede;
    `};
  padding: 30px 20px;
`;

const AddNewWrapper = styled.Pressable<{ isHovered?: boolean }>`
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #000000;
  border-radius: 15px;
  margin-top: 30px;
  ${({ isHovered }) => isHovered && `background-color: #ECECEC`};
`;

const PaymentOptionsModal = () => {
  const { savedCards } = useCheckoutStore();
  const { onAddNewCardPressed, selectPaymentOption, modalPositions } =
    useCheckoutPresenter();

  return (
    <Wrapper position={modalPositions}>
      <Title>Payment Options</Title>
      {savedCards?.map((card, i) => (
        <OptionWrapper
          isLast={i === savedCards.length - 1}
          onPress={() => {
            selectPaymentOption(card);
          }}
        >
          <Text weight='bold' size='xs' color='black'>
            {card.displayName}
          </Text>
          <Text color='black' size='xs' ellipsisLines={1}>
            {`**** **** **** ${card.last4Digits}`}
          </Text>
        </OptionWrapper>
      ))}
      <Hoverable>
        {(isHovered) => (
          <AddNewWrapper onPress={onAddNewCardPressed} isHovered={isHovered}>
            <Text weight='bold' size='xs' color='black'>
              + New Card
            </Text>
          </AddNewWrapper>
        )}
      </Hoverable>
    </Wrapper>
  );
};

export default observer(PaymentOptionsModal);
